<div *ngIf="(isLoading$ | async); else content" class="loader-line mt-5"></div>
<ng-template #content>

  <app-error-show
    (onReload)="load()"
    [Service]="senderService"
    [error]="isLoadError$.value"
    *ngIf="(isLoadError$ | async) && (leadsService.leadTasks$ | async)?.length === 0; else elseBlock"
    class="h-100"
  ></app-error-show>
  <ng-template #elseBlock>
    <div class="tasks px-4">
      <table>
        <thead>
        <th>
          <div class="th-content">НАЗВАНИЕ</div>
        </th>
        <th>
          <div class="th-content">ПОРОГ СХОЖЕСТИ, %</div>
        </th>
        <th>
          <div class="th-content">СТАТУС</div>
        </th>
        <th>
          <div class="th-content">НАЙДЕНО</div>
        </th>
        <th>
          <div class="th-content">ПРОДУКТИВНОСТЬ</div>
        </th>
        <th>
          <div class="th-content">АВТООТВЕТОВ</div>
        </th>
        <th [style.width.px]="100"></th>
        </thead>
        <tbody>
        <tr *ngFor="let data of leadsService.leadTasks$ | async" class="task"
            [class.task-status-pause]="data.pause" [class.task-status-active]="!data.pause">
          <td>
            <div class="td-name">Название:</div>
            <div class="td-content">
              <div class="before" [style.background-color]="data.color"></div>
              {{data.name ? data.name : '#' + data.id}}
            </div>
          </td>
          <td>
            <div class="td-name">Порог схожести, %</div>
            <div class="td-content">
              {{data.min_scope * 100 | number:'1.2-2'}}
            </div>
          </td>
          <td>
            <div class="td-name">Статус</div>
            <div class="td-content">
              <ng-template [ngIf]="!data.pause">

                <ng-template [ngIf]="data.type !== 'subscribe'" [ngIfElse]="subscribeRef">
                  <nz-spin [style.height.px]="10" class="d-inline-block" nzSimple
                           [nzSize]="'small'"></nz-spin>&nbsp;Работает
                </ng-template>
                <ng-template #subscribeRef>
                  Вы подписаны
                </ng-template>
              </ng-template>

              <i-feather *ngIf="data.pause" name="pause"></i-feather>
              <!--Активно-->
            </div>
          </td>
          <td>
            <div class="td-name">Найдено</div>
            <div class="td-content">
              <div *ngIf="data.type !== 'subscribe'">
                {{data.total_find}}/<span
                tooltip="Было пропущено, так как схожесть сообщений с примерами была ниже чем порог в {{data.min_scope * 100}}, но выше 45%. Если лидов нету долгое время можно понизить порог">{{data.total_skip}}</span>
              </div>
              <div *ngIf="data.type === 'subscribe'">
                {{data.total_find}}
              </div>

            </div>
          </td>
          <td>
            <div class="td-name">Продуктивность</div>
            <div class="td-content">
              <div>
                <span tooltip="Вы будете получать примерно столько лидов в сутки"
                      class="badge badge-secondary badge-sm px-3">~{{data.average_daily_find | number:'1.0-0'}}
                  лид./день</span>
              </div>
            </div>
          </td>
          <td>
            <div class="td-name">Автоответов</div>
            <div class="td-content">
              <div>
                <span *ngIf="data.auto_message"
                      class="badge badge-secondary badge-sm px-3">
                  {{data.replay_count | number:'1.0-0'}} в {{data.replay_type == 'chat' ? ' чаты' : ' лс.'}}
                </span>
                <span
                  nzTooltipPlacement="bottom" nz-tooltip
                  nzTooltipTitle="Вы можете настроить автоответы в редактировании задания"
                  *ngIf="data.replay_count == 0">—</span>
              </div>
            </div>
          </td>
          <td>
            <div class="td-content">
              <div class="control-btns">
                <div *ngIf="data.type !== 'subscribe'" (click)="togglePause(data)" class="pointer"
                     [tooltip]="data.pause ? 'Возобновить' : 'Приостановить'" placement="left">
                  <i-feather *ngIf="!data.pause" name="pause" class="mr-3"></i-feather>
                  <i-feather *ngIf="data.pause" name="play" class="text-primary mr-3"></i-feather>
                </div>
                <div *ngIf="data.type !== 'subscribe'" (click)="edit(data)" class="pointer">
                  <i-feather name="edit" class="mr-3"></i-feather>
                </div>
                <div *ngIf="data.type != 'subscribe'" (click)="delete(data)" class="pointer">
                  <i-feather name="trash-2" class="text-danger mr-3"></i-feather>
                </div>
                <div *ngIf="data.type == 'subscribe'" (click)="deletePreset(data)" tooltip="Отписаться" placement="left"
                     class="pointer">
                  <i-feather name="trash-2" class="text-danger mr-3"></i-feather>
                </div>
                <div (click)="copy(data)" class="pointer" tooltip="Копировать задание" placement="left">
                  <i-feather name="copy"></i-feather>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </ng-template>

</ng-template>
